module.exports = __webpack_public_path__ + "media/images/reward-91956c4edc37a3cd1dd10be322ebcc96.png";